(() => {
	let e = window.Difrax?.sectionLifecycle;
	if (!e) return;
	let t = [
			`a[href]`,
			`button:not([disabled])`,
			`input:not([disabled])`,
			`select:not([disabled])`,
			`textarea:not([disabled])`,
			`[tabindex]:not([tabindex="-1"])`,
		].join(`,`),
		n = (e) => {
			let t = e.dataset.headerSectionId;
			return (t && document.getElementById(t)) || e;
		},
		r = () => {
			let e =
				document.querySelector(`[data-promotion-announcement-bar]`) ||
				document.querySelector(`[data-announcement-bar]`);
			if (!e) return null;
			let t = e.dataset.announcementBarSectionId;
			return { root: e, shell: (t && document.getElementById(t)) || e };
		},
		i = (e, t) => {
			let n = t.getAttribute(`aria-controls`);
			return n ? e.querySelector(`#${CSS.escape(n)}`) : null;
		},
		a = new WeakMap();
	class o {
		closeTimers;
		header;
		lastFocused;
		section;
		constructor(e) {
			(this.header = e),
				(this.section = n(e)),
				(this.closeTimers = new WeakMap()),
				(this.lastFocused = null);
		}
		openModal(e, t, n) {
			this.lastFocused = t || document.activeElement;
			let r = this.closeTimers.get(e);
			r && window.clearTimeout(r),
				(e.hidden = !1),
				(e.inert = !1),
				document.body.classList.add(`header-overlay-open`),
				this.section?.classList.add(`shopify-section-header--overlay-open`),
				t?.setAttribute(`aria-expanded`, `true`),
				requestAnimationFrame(() => {
					e.classList.add(`is-open`),
						(n || e.querySelector(`[role="dialog"]`))?.focus();
				});
		}
		closeModal(e) {
			let t = this.closeTimers.get(e);
			t && window.clearTimeout(t),
				e.classList.remove(`is-open`),
				(e.inert = !0);
			let n = e.matches(`[data-search-overlay]`)
					? 220
					: e.matches(`[data-drawer]`)
						? 240
						: 0,
				r = () => {
					(e.hidden = !0),
						this.closeTimers.delete(e),
						this.section?.classList.remove(
							`shopify-section-header--overlay-open`,
						);
				};
			n > 0 ? this.closeTimers.set(e, window.setTimeout(r, n)) : r(),
				document.body.classList.remove(`header-overlay-open`),
				this.header
					.querySelectorAll(`[aria-controls="${CSS.escape(e.id)}"]`)
					.forEach((e) => {
						e.setAttribute(`aria-expanded`, `false`);
					}),
				this.lastFocused?.focus?.(),
				(this.lastFocused = null);
		}
		bindFocusTrap(e) {
			e.addEventListener(`keydown`, (n) => {
				if (n.key === `Escape`) {
					this.closeModal(e);
					return;
				}
				if (n.key !== `Tab`) return;
				let r = [...e.querySelectorAll(t)].filter(
					(e) => e.offsetParent !== null,
				);
				if (!r.length) return;
				let i = r[0],
					a = r[r.length - 1];
				n.shiftKey && document.activeElement === i
					? (n.preventDefault(), a.focus())
					: !n.shiftKey &&
						document.activeElement === a &&
						(n.preventDefault(), i.focus());
			});
		}
	}
	class s {
		announcementBarAdapter;
		header;
		lastScrollY;
		scrollFrame;
		section;
		resizeObserver;
		refreshAnnouncementBar;
		constructor(e) {
			(this.header = e),
				(this.section = n(e)),
				(this.announcementBarAdapter = r()),
				(this.lastScrollY = window.scrollY),
				(this.scrollFrame = null),
				(this.handleStickyScroll = this.handleStickyScroll.bind(this)),
				(this.updateTransparentContentOffset =
					this.updateTransparentContentOffset.bind(this)),
				(this.refreshAnnouncementBar = () => {
					let e = this.announcementBarAdapter?.shell,
						t = r();
					e !== t?.shell &&
						(e?.classList.remove(`shopify-section-announcement-bar--sticky`),
						e?.classList.remove(`shopify-section-announcement-bar--hidden`),
						e && this.resizeObserver?.unobserve(e),
						(this.announcementBarAdapter = t),
						t?.shell && this.resizeObserver?.observe(t.shell));
					let n = this.header.dataset.stickyHeaderEnabled === `true`;
					this.announcementBarAdapter?.shell?.classList.toggle(
						`shopify-section-announcement-bar--sticky`,
						n,
					),
						this.setAnnouncementState(`announcementBarSticky`, n),
						this.updateTransparentContentOffset(),
						n && this.handleStickyScroll();
				});
		}
		setAnnouncementState(e, t) {
			let n = t ? `true` : `false`;
			this.announcementBarAdapter?.root &&
				(this.announcementBarAdapter.root.dataset[e] = n),
				this.announcementBarAdapter?.shell &&
					(this.announcementBarAdapter.shell.dataset[e] = n);
		}
		updateTransparentContentOffset() {
			let e = this.header.dataset.transparentHeaderEnabled === `true`,
				t = this.announcementBarAdapter?.shell?.offsetHeight || 0,
				n = this.announcementBarAdapter?.shell?.classList.contains(
					`shopify-section-announcement-bar--hidden`,
				)
					? 0
					: t;
			this.section?.style.setProperty(
				`--header-transparent-offset`,
				e ? `${n}px` : `0px`,
			),
				this.section?.style.setProperty(`--header-sticky-offset`, `${n}px`);
			let r = this.header.offsetHeight || this.section?.offsetHeight || 0;
			if (!e) {
				document.body?.style?.setProperty(
					`--header-transparent-content-offset`,
					`0px`,
				);
				return;
			}
			r > 0
				? document.body?.style?.setProperty(
						`--header-transparent-content-offset`,
						`${Math.ceil(r) + 1}px`,
					)
				: document.body?.style?.removeProperty?.(
						`--header-transparent-content-offset`,
					);
		}
		init() {
			if (!this.section) return;
			a.set(this.header, this);
			let e = this.header.dataset.stickyHeaderEnabled === `true`,
				t = this.header.dataset.transparentHeaderEnabled === `true`;
			this.section.classList.toggle(`shopify-section-header--sticky`, e),
				this.section.classList.toggle(`shopify-section-header--transparent`, t),
				this.announcementBarAdapter?.shell?.classList.toggle(
					`shopify-section-announcement-bar--sticky`,
					e,
				),
				this.setAnnouncementState(`announcementBarSticky`, e),
				this.setAnnouncementState(
					`announcementBarHiddenByTransparentHeader`,
					!1,
				);
			let n = this.announcementBarAdapter?.shell?.offsetHeight || 0;
			this.section.style.setProperty(
				`--header-transparent-offset`,
				t ? `${n}px` : `0px`,
			),
				this.updateTransparentContentOffset(),
				`ResizeObserver` in window &&
					((this.resizeObserver = new ResizeObserver(
						this.updateTransparentContentOffset,
					)),
					this.resizeObserver.observe(this.header),
					this.announcementBarAdapter?.shell &&
						this.resizeObserver.observe(this.announcementBarAdapter.shell)),
				window.addEventListener(`resize`, this.updateTransparentContentOffset),
				e &&
					(window.addEventListener(`scroll`, this.handleStickyScroll, {
						passive: !0,
					}),
					this.handleStickyScroll());
		}
		handleStickyScroll() {
			this.scrollFrame === null &&
				(this.scrollFrame = requestAnimationFrame(() => {
					this.scrollFrame = null;
					let e = Math.max(window.scrollY, 0),
						t = this.announcementBarAdapter?.shell?.offsetHeight || 0,
						n = e > this.lastScrollY && e > t;
					this.announcementBarAdapter?.shell?.classList.toggle(
						`shopify-section-announcement-bar--hidden`,
						n,
					),
						this.setAnnouncementState(`announcementBarHidden`, n),
						this.section?.style.setProperty(
							`--header-sticky-offset`,
							n ? `0px` : `${t}px`,
						),
						this.section?.style.setProperty(
							`--header-transparent-offset`,
							this.header.dataset.transparentHeaderEnabled === `true` && !n
								? `${t}px`
								: `0px`,
						),
						(this.lastScrollY = e);
				}));
		}
	}
	class c {
		header;
		primaryNavigation;
		submenuEntranceTimers;
		constructor(e, t) {
			(this.header = e),
				(this.primaryNavigation = t),
				(this.submenuEntranceTimers = new WeakMap()),
				(this.closeDropdown = this.closeDropdown.bind(this));
		}
		init() {
			let e = this.primaryNavigation;
			e &&
				(e
					.querySelectorAll(`[data-dropdown-toggle], [data-dropdown-link]`)
					.forEach((e) => {
						let n = i(this.header, e),
							r = e.closest(`[data-dropdown-item]`);
						!n ||
							!r ||
							(this.bindSubmenus(r),
							r.addEventListener(`pointerenter`, () => this.openDropdown(r)),
							r.addEventListener(`pointerleave`, () => this.closeDropdown(r)),
							r.addEventListener(`focusin`, () => this.openDropdown(r)),
							r.addEventListener(`focusout`, (e) => {
								r.contains(e.relatedTarget) || this.closeDropdown(r);
							}),
							e.matches(`button, [role="button"]`) &&
								e.addEventListener(`click`, () => {
									let t = e.getAttribute(`aria-expanded`) === `true`;
									this.closeAllDropdowns(), t || this.openDropdown(r);
								}),
							e.addEventListener(`keydown`, (i) => {
								if (
									e.matches(`[role="button"]`) &&
									(i.key === `Enter` || i.key === ` `)
								) {
									i.preventDefault(), e.click();
									return;
								}
								i.key === `ArrowDown` &&
									(i.preventDefault(),
									this.openDropdown(r),
									n.querySelector(t)?.focus());
							}));
					}),
				e.addEventListener(`keydown`, (t) => {
					if (
						(t.key === `Escape` &&
							(this.closeAllDropdowns(),
							e.querySelector(`[aria-expanded="true"]`)?.focus()),
						t.key !== `ArrowLeft` && t.key !== `ArrowRight`)
					)
						return;
					let n = [...e.querySelectorAll(`.site-header__nav-link`)],
						r = n.indexOf(document.activeElement);
					r < 0 ||
						(t.preventDefault(),
						n[
							(r + (t.key === `ArrowRight` ? 1 : -1) + n.length) % n.length
						].focus());
				}),
				document.addEventListener(`click`, (t) => {
					e.contains(t.target) || this.closeAllDropdowns();
				}));
		}
		bindSubmenus(e) {
			if (!e) return;
			let t = [...e.querySelectorAll(`.site-header__dropdown-group`)],
				n = [...e.querySelectorAll(`[data-submenu-panel]`)],
				r = [...e.querySelectorAll(`[data-submenu-promotion]`)];
			if (!t.length || !n.length) return;
			let i = (i) => {
				this.clearSubmenuEntrances(e),
					n.forEach((e) => {
						e.hidden = e.id !== i;
					}),
					r.forEach((e) => {
						e.hidden = e.getAttribute(`data-submenu-promotion`) !== i;
					}),
					t.forEach((e) => {
						let t = e.querySelector(`[data-submenu-link]`);
						if (!t) return;
						let n = e.getAttribute(`data-submenu-group`) === i;
						t.setAttribute(`aria-expanded`, n ? `true` : `false`);
					});
			};
			t.forEach((t) => {
				let n = t.getAttribute(`data-submenu-group`);
				t.addEventListener(`pointerenter`, () => {
					if (!n) {
						this.closeSubmenus(e);
						return;
					}
					i(n);
				}),
					t.addEventListener(`focusin`, () => {
						if (!n) {
							this.closeSubmenus(e);
							return;
						}
						i(n);
					});
			});
		}
		closeSubmenus(e) {
			this.clearSubmenuEntrances(e),
				e.querySelectorAll(`[data-submenu-panel]`).forEach((e) => {
					e.hidden = !0;
				}),
				e.querySelectorAll(`[data-submenu-promotion]`).forEach((e) => {
					e.hidden = !0;
				}),
				e.querySelectorAll(`[data-submenu-link]`).forEach((e) => {
					e.setAttribute(`aria-expanded`, `false`);
				});
		}
		openDefaultSubmenu(e) {
			let t = e
				.querySelector(`[data-submenu-group]`)
				?.getAttribute(`data-submenu-group`);
			t &&
				(e.querySelectorAll(`[data-submenu-panel]`).forEach((e) => {
					let n = e.id === t;
					(e.hidden = !n),
						n ? this.startSubmenuEntrance(e) : this.clearSubmenuEntrance(e);
				}),
				e.querySelectorAll(`[data-submenu-promotion]`).forEach((e) => {
					let n = e.getAttribute(`data-submenu-promotion`) === t;
					(e.hidden = !n),
						n ? this.startSubmenuEntrance(e) : this.clearSubmenuEntrance(e);
				}),
				e.querySelectorAll(`[data-submenu-link]`).forEach((e) => {
					e.setAttribute(
						`aria-expanded`,
						e.getAttribute(`aria-controls`) === t ? `true` : `false`,
					);
				}));
		}
		startSubmenuEntrance(e) {
			this.clearSubmenuEntrance(e),
				e.classList.add(`is-entering`),
				this.submenuEntranceTimers.set(
					e,
					window.setTimeout(() => {
						e.classList.remove(`is-entering`),
							this.submenuEntranceTimers.delete(e);
					}, 700),
				);
		}
		clearSubmenuEntrance(e) {
			let t = this.submenuEntranceTimers.get(e);
			t && window.clearTimeout(t),
				this.submenuEntranceTimers.delete(e),
				e.classList.remove(`is-entering`);
		}
		clearSubmenuEntrances(e) {
			e.querySelectorAll(
				`[data-submenu-panel], [data-submenu-promotion]`,
			).forEach((e) => {
				this.clearSubmenuEntrance(e);
			});
		}
		openDropdown(e) {
			if (!e) return;
			let t = e.querySelector(`[data-dropdown-toggle], [data-dropdown-link]`),
				n = t ? i(this.header, t) : null;
			if (!n || !t) return;
			let r = n.hidden;
			(n.hidden = !1),
				t.setAttribute(`aria-expanded`, `true`),
				r && this.openDefaultSubmenu(e);
		}
		closeDropdown(e) {
			if (!e) return;
			let t = e.querySelector(`[data-dropdown-toggle], [data-dropdown-link]`),
				n = t ? i(this.header, t) : null;
			!n ||
				!t ||
				((n.hidden = !0),
				this.closeSubmenus(e),
				t.setAttribute(`aria-expanded`, `false`));
		}
		closeAllDropdowns() {
			this.primaryNavigation
				?.querySelectorAll(`[data-dropdown-item]`)
				.forEach((e) => {
					this.closeDropdown(e);
				});
		}
	}
	class l {
		drawer;
		header;
		mobileNavigation;
		modalController;
		submenuCloseTimers;
		constructor(e, t) {
			(this.header = e),
				(this.modalController = t),
				(this.drawer = e.querySelector(`[data-drawer]`)),
				(this.mobileNavigation =
					e.querySelector(`[data-mobile-navigation]`) || this.drawer),
				(this.submenuCloseTimers = new WeakMap());
		}
		init() {
			!this.drawer ||
				!this.mobileNavigation ||
				(this.header.querySelectorAll(`[data-drawer-open]`).forEach((e) => {
					e.addEventListener(`click`, () => this.openDrawer(e));
				}),
				this.drawer.querySelectorAll(`[data-drawer-close]`).forEach((e) => {
					e.addEventListener(`click`, () => this.closeDrawer());
				}),
				this.mobileNavigation
					.querySelectorAll(`[data-mobile-submenu-trigger]`)
					.forEach((e) => {
						let t = i(this.mobileNavigation, e);
						e.addEventListener(`click`, () => {
							this.openSubmenu(e, t);
						});
					}),
				this.mobileNavigation
					.querySelectorAll(`[data-mobile-submenu-close]`)
					.forEach((e) => {
						e.addEventListener(`click`, () => {
							let t = e.closest(`.header-drawer__submenu`);
							this.closeSubmenu(t);
						});
					}),
				this.modalController.bindFocusTrap(this.drawer),
				this.drawer.addEventListener(`keydown`, (e) => {
					e.key === `Escape` && this.resetSubmenus();
				}));
		}
		openDrawer(e) {
			this.resetSubmenus(),
				this.modalController.openModal(
					this.drawer,
					e,
					this.drawer.querySelector(`[role="dialog"]`),
				);
		}
		closeDrawer() {
			this.resetSubmenus(), this.modalController.closeModal(this.drawer);
		}
		openSubmenu(e, n) {
			n &&
				this.setSubmenuState(n, !0, () => {
					n.querySelector(t)?.focus();
				});
		}
		closeSubmenu(e) {
			e &&
				(this.closeSubmenuTree(e),
				this.mobileNavigation
					.querySelector(`[aria-controls="${CSS.escape(e.id)}"]`)
					?.focus());
		}
		closeSubmenuTree(e) {
			e.querySelectorAll(`.header-drawer__submenu`).forEach((e) => {
				this.setSubmenuState(e, !1);
			}),
				this.setSubmenuState(e, !1);
		}
		resetSubmenus() {
			this.mobileNavigation
				.querySelectorAll(`.header-drawer__submenu`)
				.forEach((e) => {
					this.setSubmenuState(e, !1);
				});
		}
		setSubmenuState(e, t, n = void 0) {
			let r = this.submenuCloseTimers.get(e);
			if (
				(r && window.clearTimeout(r),
				this.mobileNavigation
					.querySelector(`[aria-controls="${CSS.escape(e.id)}"]`)
					?.setAttribute(`aria-expanded`, t ? `true` : `false`),
				t)
			) {
				let t = e.hidden || !e.classList.contains(`is-open`);
				(e.hidden = !1),
					(e.inert = !1),
					t
						? (e.classList.remove(`is-open`),
							e.getBoundingClientRect?.(),
							requestAnimationFrame(() => {
								e.hidden ||
									e.inert ||
									(e.classList.add(`is-open`),
									requestAnimationFrame(() => {
										e.hidden || e.inert || n?.();
									}));
							}))
						: (e.classList.add(`is-open`), n?.());
				return;
			}
			e.classList.remove(`is-open`),
				(e.inert = !0),
				!e.hidden &&
					this.submenuCloseTimers.set(
						e,
						window.setTimeout(() => {
							(e.hidden = !0), this.submenuCloseTimers.delete(e);
						}, 320),
					);
		}
	}
	class u {
		header;
		headerBar;
		modalController;
		searchOverlay;
		constructor(e, t) {
			(this.header = e),
				(this.modalController = t),
				(this.searchOverlay = e.querySelector(`[data-search-overlay]`)),
				(this.headerBar = e.querySelector(`.site-header__bar`));
		}
		init() {
			this.searchOverlay &&
				(window.addEventListener(`resize`, () => this.updateSearchOffset()),
				this.header.querySelectorAll(`[data-search-open]`).forEach((e) => {
					e.addEventListener(`click`, () => {
						this.updateSearchOffset(),
							this.modalController.openModal(
								this.searchOverlay,
								e,
								this.searchOverlay.querySelector(`[data-search-input]`),
							);
					});
				}),
				this.searchOverlay
					.querySelectorAll(`[data-search-close]`)
					.forEach((e) => {
						e.addEventListener(`click`, () =>
							this.modalController.closeModal(this.searchOverlay),
						);
					}),
				this.modalController.bindFocusTrap(this.searchOverlay));
		}
		updateSearchOffset() {
			if (!this.searchOverlay) return;
			let e = this.headerBar?.getBoundingClientRect?.(),
				t = this.headerBar?.offsetHeight || 80,
				n = Math.max(e?.bottom ?? t, 0);
			this.searchOverlay.style.setProperty(
				`--header-search-offset`,
				`${Math.round(n)}px`,
			);
		}
	}
	class d {
		header;
		constructor(e) {
			this.header = e;
		}
		init() {
			let e = this.header.querySelector(`[data-cart-count]`),
				t = this.header.querySelector(`[data-cart-link]`);
			if (!e || !t) return;
			let n = (n) => {
					(e.textContent = String(n)),
						e.classList.toggle(`is-empty`, n === 0),
						t.setAttribute(`aria-label`, `Winkelwagen, ${n} items`);
				},
				r = async (e) => {
					let t = e instanceof CustomEvent ? e.detail?.cart : void 0;
					if (typeof t?.item_count == `number`) {
						n(t.item_count);
						return;
					}
					try {
						let e = await fetch(`/cart.js`, { credentials: `same-origin` });
						if (!e.ok) return;
						let t = await e.json();
						n(t.item_count);
					} catch (e) {
						console.warn(`Unable to refresh cart count`, e);
					}
				};
			[
				`cart:updated`,
				`cart:refresh`,
				`cart:change`,
				`ajaxCart:updated`,
			].forEach((e) => {
				document.addEventListener(e, r);
			});
		}
	}
	class f {
		header;
		primaryNavigation;
		constructor(e, t) {
			(this.header = e), (this.primaryNavigation = t);
		}
		init() {
			let e = this.header.querySelector(`.site-header__bar-inner`),
				t = this.primaryNavigation,
				n = t?.querySelector(`.site-header__nav-list`),
				r = this.header.querySelector(`.site-header__actions`),
				i = this.header.querySelector(`.site-header__logo`);
			if (!e || !t || !n || !r || !i || !(`ResizeObserver` in window)) return;
			let a = 0,
				o = null,
				s = () => {
					if (t.offsetParent !== null) {
						let e = Math.ceil(n.scrollWidth);
						e > 0 && (a = e);
					}
					return a;
				},
				c = () => {
					if (
						((o = null),
						!window.matchMedia(`(min-width: 990px)`).matches ||
							e.classList.contains(`site-header__bar-inner--underneath`))
					) {
						this.header.classList.remove(`is-menu-condensed`);
						return;
					}
					let t = s();
					if (!t) return;
					let n = t + r.offsetWidth + i.offsetWidth + 180;
					this.header.classList.toggle(`is-menu-condensed`, n > e.clientWidth);
				},
				l = () => {
					o !== null && cancelAnimationFrame(o), (o = requestAnimationFrame(c));
				},
				u = new ResizeObserver(l);
			u.observe(e),
				u.observe(n),
				u.observe(r),
				u.observe(i),
				window.addEventListener(`load`, l, { once: !0 }),
				l();
		}
	}
	class p {
		header;
		modalController;
		modules;
		primaryNavigation;
		constructor(e) {
			(this.header = e),
				(this.primaryNavigation = e.querySelector(`[data-primary-navigation]`)),
				(this.modalController = new o(e)),
				(this.modules = [
					new s(e),
					new c(e, this.primaryNavigation),
					new l(e, this.modalController),
					new u(e, this.modalController),
					new d(e),
					new f(e, this.primaryNavigation),
				]),
				this.init();
		}
		init() {
			this.modules.forEach((e) => {
				e.init();
			});
		}
	}
	let m = window.Difrax || {};
	(m.HeaderController = p), (window.Difrax = m);
	let h = () => {
		requestAnimationFrame(() => {
			document.querySelectorAll(`[data-navigation-module]`).forEach((e) => {
				a.get(e)?.refreshAnnouncementBar();
			});
		});
	};
	document.addEventListener(`shopify:section:load`, h),
		document.addEventListener(`shopify:section:unload`, h),
		e.register({
			name: `navigation-module`,
			selector: `[data-navigation-module]`,
			init(e) {
				new p(e);
			},
		});
})();
